module.exports = __webpack_public_path__ + "static/media/hd.5ea3a648.png";